
export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Free Consultation',
      description: 'Start with a relaxed, no-pressure consultation where we listen to your concerns and discuss your dental needs in a comfortable setting.',
      icon: 'ri-chat-3-line'
    },
    {
      number: '02',
      title: 'Personalised Plan',
      description: 'We create a customised treatment plan tailored to your comfort level, including sedation options if needed.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '03',
      title: 'Gentle Treatment',
      description: 'Experience pain-free, anxiety-free dentistry with our gentle techniques and supportive team by your side.',
      icon: 'ri-heart-pulse-line'
    },
    {
      number: '04',
      title: 'Ongoing Support',
      description: 'We provide continuous care and support, ensuring you feel confident and comfortable at every visit.',
      icon: 'ri-user-heart-line'
    }
  ];

  return (
    <section id="process" className="py-24 px-6 bg-[#fafaf8]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block bg-[#d0a24f]/10 rounded-full px-6 py-2 mb-4">
            <span className="text-[#d0a24f] text-sm font-semibold whitespace-nowrap">How It Works</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#444c42] mb-6">
            Your Journey to Stress-Free Dentistry
          </h2>
          <p className="text-lg text-[#7A8178] max-w-2xl mx-auto">
            We've made it simple and comfortable. Here's what to expect when you choose Beaulieu Dental for your anxious patient care.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-3xl p-8 h-full hover:shadow-xl transition-all duration-300 border border-[#d0a24f]/10">
                <div className="w-16 h-16 flex items-center justify-center bg-[#d0a24f]/10 rounded-2xl mb-6">
                  <i className={`${step.icon} text-3xl text-[#d0a24f]`}></i>
                </div>
                <div className="text-6xl font-bold text-[#d0a24f]/10 mb-4">{step.number}</div>
                <h3 className="text-xl font-bold text-[#444c42] mb-3">{step.title}</h3>
                <p className="text-[#7A8178] leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-[#d0a24f]/30"></i>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} className="bg-[#d0a24f] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#dcb964] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
            Begin Your Journey
          </button>
        </div>
      </div>
    </section>
  );
}
